import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as licenseActions from '../../../redux/css-admin/licenseManager/actions'
import * as licenseOperations from '../../../redux/css-admin/licenseManager/operations'
import subscriptionOperations from '../../../redux/css-admin/subscriptionManager/operations'
import sitesOperations from '../../../redux/sitesManager/operations'
import { clearUsers } from '../../../redux/css-admin/userManager/actions'
import ErrorBoundary from 'components/ErrorBoundary'
import Loading from 'components/Loading/Loading'
import EditLicenseModal from '../licenses/EditLicenseModal'
import LicenseHeader from './LicenseHeader'
import LicenseSummary from './LicenseSummary'

const LicenseManager = props => {
  const {
    clearUsers,
    fetchSite,
    getLicense,
    isLoading,
    isSaving,
    license,
    match,
    push,
    reloadSubscription,
    sites,
    subscriptionManager,
  } = props

  const [hasInactiveNetSuiteCustomer, setHasInactiveNetSuiteCustomer] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [subscription, setSubscription] = useState()
  const [selectedSite, setSelectedSite] = useState()

  const getLicenseId = () => match.params.id

  const loadLicense = () => {
    const id = getLicenseId()
    if (!license || license.id !== parseInt(id, 10)) {
      getLicense({ licenseId: id })
    }
  }

  //mount
  useEffect(() => {
    loadLicense()
  }, [])

  useEffect(() => {
    if (license && license.subscriptionId) {
      reloadSubscription(license.subscriptionId)
    }

    if (license && license.siteId) {
      fetchSite(license.siteId)
    }
  }, [license])

  useEffect(() => {
    if (sites && sites.data && license && license.siteId) {
      const filteredSite = sites.data.filter(
        site => site.id === license.siteId,
      )[0]

      if (!selectedSite) {
        setSelectedSite(filteredSite)
      }

      if (selectedSite && selectedSite.id !== filteredSite.id) {
        setSelectedSite(filteredSite)
      }

      if (filteredSite && filteredSite.netSuiteCustomer) {
        setHasInactiveNetSuiteCustomer(filteredSite.netSuiteCustomer.inactive)
      }
    }
  }, [sites.data])

  useEffect(() => {
    if (
      license &&
      license.subscriptionId &&
      subscriptionManager.subscriptions.has(license.subscriptionId.toString())
    ) {
      setSubscription(
        subscriptionManager.subscriptions.get(
          license.subscriptionId.toString(),
        ),
      )
    }
  }, [subscriptionManager.subscriptions])

  const backToSearch = () => {
    clearUsers()
    const pathname = match.path
    const location = pathname.substring(0, pathname.lastIndexOf('/'))
    push(location)
  }

  const toggleEditModal = () => setShowEditModal(!showEditModal)

  return (
    <ErrorBoundary>
      <p>
        <Button color="primary" onClick={() => backToSearch(false)} outline>
          <i className="fas fa-chevron-left" />
          &nbsp; Back to Search
        </Button>
      </p>
      <Loading isLoading={isLoading} />
      <Loading isLoading={isSaving} message="Saving..." />
      {license && (
        <div>
          <LicenseHeader license={license} toggleEditModal={toggleEditModal} />
          <LicenseSummary
            license={license}
            site={selectedSite}
            subscription={subscription}
          />
        </div>
      )}
      {showEditModal && (
        <EditLicenseModal
          isOpen={showEditModal}
          license={license}
          subscription={subscription}
          toggle={toggleEditModal}
          hasInactiveNetSuiteCustomer={hasInactiveNetSuiteCustomer}
        />
      )}
    </ErrorBoundary>
  )
}

LicenseManager.propTypes = {
  clearUsers: PropTypes.func,
  getLicense: PropTypes.func,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  license: PropTypes.object,
  match: PropTypes.object,
  push: PropTypes.func,
  savingLicenseSuccess: PropTypes.func,
  subscription: PropTypes.object,
}

const mapStateToProps = ({
  licenseManager,
  subscriptionManager,
  sitesManager,
}) => {
  return {
    ...licenseManager,
    subscriptionManager,
    sites: sitesManager.sites,
  }
}

const mapDispatchToProps = {
  ...licenseActions,
  ...licenseOperations,
  fetchSite: sitesOperations.fetchSite,
  clearUsers: clearUsers,
  reloadSubscription: subscriptionOperations.reloadSubscription,
  push,
}

export default connect(mapStateToProps, mapDispatchToProps)(LicenseManager)



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/License.js